import { render, staticRenderFns } from "./accessConfiguration.vue?vue&type=template&id=133dd986&scoped=true"
import script from "./accessConfiguration.vue?vue&type=script&lang=js"
export * from "./accessConfiguration.vue?vue&type=script&lang=js"
import style0 from "./accessConfiguration.vue?vue&type=style&index=0&id=133dd986&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133dd986",
  null
  
)

export default component.exports